
import selectOption from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    return {
      list: [],
      headData: [
        {
          name: 'receivableId',
          columnProps: {
            prop: 'receivableId',
            label: '应收ID',
            width: 80,
          },
        },
        {
          name: 'content',
          columnProps: {
            prop: 'content',
            label: '收款内容',
            width: 100,
          },
          getText: ({ row }) => {
            if (this.freeTypeList.find((item) => item.code === row.content)) {
              return this.freeTypeList.find((item) => item.code === row.content).name
            }
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
          },
        },
        {
          name: 'customer',
          columnProps: {
            prop: 'customer',
            label: '付款方',
            width: 160,
          },
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            prop: 'sourceOrderType',
            label: '来源单类型',
            width: 120,
          },
          getText: ({ row }) => selectOption.sourceOrderTypeDict[row.sourceOrderType],
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            prop: 'sourceOrderId',
            label: '来源单ID',
          },
        },
        {
          name: 'periodDays',
          columnProps: {
            prop: 'periodDays',
            label: '扣款周期天数',
            width: 120,
          },
        },
        {
          name: 'amount',
          columnProps: {
            prop: 'amount',
            label: '扣款计划金额',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 80,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row, $index }) => {
            const handleList = JSON.parse(JSON.stringify(this.handleList))
            handleList.forEach((item) => {
              item.action = () => (this[item.name](row, $index))
            })
            return handleList
          },
        },
      ],
      handleList: [
        { name: 'deteleItem', label: '移除' },
      ],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      loading: false,
    }
  },
  methods: {
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getList()
    },
  },
}
